import Request from "@/common/Request"
import store from '@/store/index'

export default class Product {

    //get products list
    async listAll(page) {
        return (await new Request().getWithfilter("products",{
            page: page,
            "user_hash": store.getters.deviceToken
        })) || {
            data: null,
            links: null,
            meta: null,
        }
    }

    //product details
    async getProductDetails(productId) {
        return (
            (await new Request().getWithfilter(`products/${productId}`,{
                "user_hash": store.getters.deviceToken
            })) || { data: null }
        )
    }

    // get home featured Products
    async getHomeFeaturedProducts() {
        let params = {
            limit:10,
            "user_hash": store.getters.deviceToken
        }
        return (
            (await new Request().getWithfilter("products/featured",params)) || { data: null }
        )
    }

    // get meals list
    // async listAllMeals() {
    //     return (await new Request().getWithfilter("meals",{
    //         "user_hash": store.getters.deviceToken
    //     })) || {
    //         data: null,
    //         links: null,
    //         meta: null,
    //     }
    // }

    //filtered Products
    async filteredProducts(params) {
        return (await new Request().getWithfilter("products", params)) || {
            data: null,
            links: null,
            meta: null,
        }
    }

    async addToWishlist(payload) {
        return (
            (await new Request().post("wishlist", payload, {}))
        ) 
    }

    async filteredWishlistProducts(params) {
        return (await new Request().getWithfilter("wishlist", params)) || {
            data: null,
            links: null,
            meta: null,
        }
    }
}
